<template>
    <div class='card' v-loading="loading">
        <div class='card-header'>
          <el-row type="flex" justify="center">
            <el-col :span="12">
                <label class='az-content-label' style='text-transform: none'>
                      {{isbgl?'Last Tax Year Lodged' :'Tax Payable / Refundable Last Lodgement '}}
                </label>
            </el-col>
            <el-col :span="8">
                <el-input 
                    style="fload:right"
                    size='mini'
                    v-model="message" 
                    prefix-icon="el-icon-search"
                    placeholder="Search">
                </el-input>
            </el-col>
            <el-col :span="4" >
                <span style="float:right">
                  <el-button size="mini" v-on:click="other.exportExcel('Tax.xlsx')">Excel</el-button>
                  <el-button size="mini" v-on:click="generateReport">PDF</el-button>
                </span>
            </el-col>
           </el-row>
        </div>
        <div class='card-body tx-13' >
            <el-table
                :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                stripe
                size="small"
                style="width: 100%;font-size:13px"
                :default-sort = "{prop: 'fund_name', order: 'ascending'}"
                >
                <el-table-column
                prop="fund_name,fund_code"
                label="Fund Name"
                sortable
                style='font-weight:500'
                >
                <template slot-scope="scope" >
                    <div style='font-weight:500'>
                    <router-link :to="{path:'/funddashboard/'+scope.row['fund_code'],query:{name:scope.row['fund_name']}}">{{isSample?'Sample Family Super Fund '+(index+1):scope.row['fund_name']}} </router-link>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="tax_year"
                label="Last Tax Year Lodged"
                sortable
                >
                </el-table-column>
               <el-table-column
                v-if="isbgl===false"
                prop="refundable"
                label="Tax Refundable ($)"
                sortable
                >
                </el-table-column>
                <el-table-column
                v-if="isbgl===false"
                prop="payable"
                label="Tax Payable ($)"
                sortable
                >
                </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 60px;">
            <el-pagination
                :current-page="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                @current-change="current_change">
            </el-pagination>
            </div>
            <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="Cash at Bank"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="90%"
    
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
        <section slot="pdf-content">
            <table id="table" class="table">
              <thead>
                <tr>
                  <th>Fund Name</th>
                  <th>Last Tax Year Lodged</th>
                  <th>Tax Refundable</th>
                  <th>Tax Payable</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tax,index) in taxs" :key="tax.fund_code">
                  <td style='font-weight:500'><router-link :to="{path:'/funddashboard/'+tax.fund_code,query:{name:tax.fund_name}}">{{isSample?'Sample Family Super Fund '+(index+1):tax.fund_name}} </router-link></td>
                  <td>{{tax.tax_year}}</td>
                  <td>{{tax.refundable==='N/A'?tax.refundable:currentformats.AUformat(tax.refundable)}}</td>
                  <td>{{tax.payable==='N/A'?tax.payable:currentformats.AUformat(tax.payable)}}</td>
                </tr>
              </tbody>
            </table>
        </section>
        </vue-html2pdf>
        </div>

        
    </div>
</template>
<script>
import currentformats from '../../../utils/currentformats'
import dateformats from '../../../utils/dateformats'
import VueHtml2pdf from 'vue-html2pdf'
import other from '../../../utils/other'
export default {
    name:'tax',
    components: { 
      VueHtml2pdf,
    },
    data(){
        return{
            isSample:false,
            currentformats:currentformats,
            dateformats:dateformats,
            message:'',
            isbgl:false,
            taxs:[],
            loading:true,
            total: 0,
            pagesize:15,
            currentPage:1,
            other:other
        }
    },
    computed:{
      tableData:function(){
        var message=this.message;
        if(message){
          return  this.taxs.filter(function(dataNews){
            return Object.keys(dataNews).some(function(key){
              return String(dataNews[key]).toLowerCase().indexOf(message) > -1
            })
          })
        }
        return this.taxs
      }
    },
    created(){
        this.getInsuranceData();
    },
    methods:{
        getInsuranceData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample=userdetail['sample'];
            this.isbgl = userdetail['isBGL'];
            let brand = localStorage.getItem('brand_code')
            
            this.$api.adviserdashboard_api.adviser_tax(brand).then(response =>{
                this.taxs = response.data['taxs']
                this.total = this.taxs.length
                this.loading=false;
            });
        
        },
        current_change:function(currentPage){
            this.currentPage = currentPage;
        },
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
    }
}
</script>
<style>
/* .tableFixHead          { overflow: auto; height: 500px; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; background-color: white;} */

</style>